import React, { useState } from 'react';
import styles from './Checkout.module.css';
import { useLocation, Link } from 'react-router-dom';

import type { ItemProps } from '../assets/types';
import { calculateTotal } from '../assets/helpers';

function CheckoutScreen(props: any): JSX.Element {
  const submitOrder = (): void => {
    console.log(order)
    fetch('https://soarin-donuts-backend.fly.dev/api/create-order', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(order)
    }).then(res => {
      console.log(res)
    }).catch(err => {
      console.log(err)
    });
  };

  const location = useLocation();
  console.log(props, 'props');
  const products: ItemProps[] = location?.state?.data ?? [];
  console.log(products, 'orders');

  const [order, setOrder] = useState({
    date: Date.now(),
    items: products
  })

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Checkout</h1>
      <ul className={styles.productList}>
        {products.map((product) => (
          <li className={styles.productItem} key={product.donut.name}>
            <span className={styles.productName}>{product.donut.name}  x{product.quantity}</span>
            <span className={styles.productPrice}>${product.donut.price}</span>
          </li>
        ))}
      </ul>
      <div className={styles.totalSection}>
        <span className={styles.totalLabel}>Total:</span>
        <span className={styles.totalAmount}>
          ${calculateTotal(products)}
        </span>
      </div>
      <form action="/api/create-order" method='post' className={styles.addressForm}>
        <div className={styles.addressLabel}>Shipping Address:</div>
        <input placeholder="Full Name" />
        <input placeholder="Street Address" />
        <div className={styles.addressRow}>
          <input placeholder="City" />
          <input placeholder="State" />
          <input placeholder="Zip Code" />
        </div>
      </form>
      <Link className={styles.btn } to={{ pathname: '/Menu' }} state={{ data: products }}>Go Back </Link>
      <Link onClick={submitOrder} className={styles.btn} to={{ pathname: '/Acknowledgement' }}>Place Order</Link>
    </div>
  );
}
export default CheckoutScreen;
